import { donorStatus } from "@/helpers/statusHelper";
import {compareStr} from "@/utils/compareStrings";
 
// PERFIS

const opoProfiles = ["TBO", "TOPC"];

// const adminProfiles = [
//   "ADM",
//   "DIR",
//   "PCET",
//   "EDOT",
//   "PBO",
//   "COSET",
//   "TCENT",
//   "POPC",
// ];

const controlAdmProfiles = ["ADM"];

// STATUS PCR
const pcrFinalStatus = [
  donorStatus.DOACAO_EFETIVADA.slug,
  donorStatus.TRANSPANTE_EFETIVADO.slug,
];

const pcrDadosMorteAllowed = [
  donorStatus.PACIENTE_IDENTIFICADO.slug,
  donorStatus.PACIENTE_NAO_IDENTIFICADO.slug,
  donorStatus.PACIENTE_EM_AVALI_NEUROLOGICA.slug,
  donorStatus.DOACAO_INICIADA.slug,
  donorStatus.POTENCIAL_DOADOR.slug,
  donorStatus.POTENCIAL_DOADOR_CORN.slug,
  donorStatus.DOACAO_AUTORIZADA.slug,
  donorStatus.ORGAO_CAPTADO.slug,
];

const pcrAvaliacaoAllowed = [
  donorStatus.POTENCIAL_DOADOR_CORN.slug,
  donorStatus.PACIENTE_INAPTO.slug,
];

const pcrAceiteAllowed = [
  donorStatus.POTENCIAL_DOADOR.slug,
  donorStatus.AGUARDANDO_AUT_FAMILIAR.slug,
  donorStatus.DOACAO_AUTORIZADA.slug,
  donorStatus.DOACAO_NAO_AUTORIZADA.slug,
];

const pcrCaptacaoBlocked = [
  donorStatus.PACIENTE_IDENTIFICADO.slug,
  donorStatus.POTENCIAL_DOADOR.slug,
  donorStatus.AGUARDANDO_AUT_FAMILIAR.slug,
  donorStatus.DOACAO_NAO_AUTORIZADA.slug,
  donorStatus.FINALIZADO_SEM_DOACAO.slug,
  donorStatus.PME_NAO_CONCLUIDO.slug,
  donorStatus.CONCLUIDO_SEM_TRANSPLANTE.slug,
  donorStatus.POTENCIAL_DOADOR_CORN.slug,
  donorStatus.DOACAO_EFETIVADA.slug,
  donorStatus.DOADOR_CORNEA_PRESERVADAS.slug,
  donorStatus.DOADOR_CORNEA_DESCARTADAS.slug,
  donorStatus.DOADOR_CORNEA_TRANSPLANTADA.slug,
  donorStatus.PACIENTE_NAO_IDENTIFICADO.slug,
  donorStatus.PACIENTE_INAPTO.slug,
  donorStatus.PACIENTE_EM_AVALI_NEUROLOGICA.slug,
  donorStatus.DOACAO_NAO_EFETIVADA.slug,
  donorStatus.AGUARDANDO_AVAL_MEDICA.slug,
  donorStatus.TRANSPANTE_EFETIVADO.slug,
  donorStatus.FINALIZADO_SEM_ENTREVISTA.slug,
];

const pcrOrgaosCaptadosAllowed = [
  donorStatus.DOACAO_EFETIVADA.slug,
  donorStatus.TRANSPANTE_EFETIVADO.slug,
  donorStatus.CONCLUIDO_SEM_TRANSPLANTE.slug,
];

// STATUS ME

const meFinalStatus = [
  donorStatus.FINALIZADO_SEM_DOACAO.slug,
  donorStatus.PME_NAO_CONCLUIDO.slug,
  donorStatus.DOACAO_NAO_EFETIVADA.slug,
  donorStatus.DOACAO_INICIADA.slug,
  donorStatus.DOACAO_EFETIVADA.slug,
];

const meGlasgowAllowed = [
  donorStatus.PACIENTE_IDENTIFICADO.slug,
  donorStatus.POTENCIAL_DOADOR.slug,
  donorStatus.PACIENTE_NAO_IDENTIFICADO.slug,
  donorStatus.PACIENTE_EM_AVALI_NEUROLOGICA.slug,
  donorStatus.AGUARD_REENVIO_ABERTURA_PME.slug
];

const meValidacaoAllowed = [
  donorStatus.AGUARDANDO_AVAL_MEDICA.slug,
  donorStatus.PACIENTE_INAPTO.slug,
];

const mePosAvaliacaoAllowed = [
  donorStatus.DOACAO_AUTORIZADA.slug,
  donorStatus.DOACAO_NAO_AUTORIZADA.slug,
  donorStatus.DOACAO_INICIADA.slug,
  donorStatus.PME_CONCLUIDO.slug,
];

const meCaptacaoBlocked = [
  donorStatus.PACIENTE_IDENTIFICADO.slug,
  donorStatus.POTENCIAL_DOADOR_CORN.slug,
  donorStatus.POTENCIAL_DOADOR.slug,
  donorStatus.AGUARD_ENCER_PME.slug,
  donorStatus.DOACAO_NAO_AUTORIZADA.slug,
  donorStatus.FINALIZADO_SEM_DOACAO.slug,
  donorStatus.PME_NAO_CONCLUIDO.slug,
  donorStatus.CONCLUIDO_SEM_TRANSPLANTE.slug,
  donorStatus.DOACAO_EFETIVADA.slug,
  donorStatus.DOADOR_CORNEA_PRESERVADAS.slug,
  donorStatus.DOADOR_CORNEA_DESCARTADAS.slug,
  donorStatus.DOADOR_CORNEA_TRANSPLANTADA.slug,
  donorStatus.PACIENTE_NAO_IDENTIFICADO.slug,
  donorStatus.PACIENTE_INAPTO.slug,
  donorStatus.PACIENTE_EM_AVALI_NEUROLOGICA.slug,
  donorStatus.AGUARDANDO_AVAL_MEDICA.slug,
  donorStatus.TRANSPANTE_EFETIVADO.slug,
  donorStatus.FINALIZADO_SEM_ENTREVISTA.slug,
  donorStatus.PME_CONCLUIDO.slug,
  donorStatus.AGUARD_ENCER_PME.slug,
];

const meOrgaosCaptadosAllowed = [
  donorStatus.DOACAO_EFETIVADA.slug,
  donorStatus.TRANSPANTE_EFETIVADO.slug,
  donorStatus.CONCLUIDO_SEM_TRANSPLANTE.slug,
];

const mePMEAwaitingClosure = [
  donorStatus.AGUARD_ENCER_PME.slug,
  donorStatus.PME_NAO_CONCLUIDO.slug,
  donorStatus.PME_CONCLUIDO.slug, 
];

// FUNÇÕES AUXILIARES

function getStatusSlug(item) {
  return item?.donor_status?.slug ?? null;
}

function isOpoProfile(profile) {
  return opoProfiles.includes(profile);
}

// function isAdminProfile(profile) {
//   return adminProfiles.includes(profile);
// }

function canAccessAdmControl(profile) {
  return controlAdmProfiles.includes(profile);
}

function isPCR(item) {
  return Number(item?.kind_of_donor_id) === 2;
}

function isME(item) {
  return Number(item?.kind_of_donor_id) === 1;
}

function isMeFinalStatus(item, status) {
  if (status === donorStatus.PME_NAO_CONCLUIDO.slug) {
    const [{ tissue_harvesting_only_flg }] = item?.encerramento_pme ?? [{}]
    
    return compareStr(tissue_harvesting_only_flg, "nao")
  }

  return meFinalStatus.includes(status);
}

function isMeAfterMedical(item, status) {
  if (status === donorStatus.PME_NAO_CONCLUIDO.slug) {
    const [{ tissue_harvesting_only_flg }] = item?.encerramento_pme ?? [{}]
    return compareStr(tissue_harvesting_only_flg, "sim");
  }

  return mePosAvaliacaoAllowed.includes(status);
}

// MENU OPO

function getOpoMenu() {
  return [
    {
      title: "Visualizar Dados do Paciente",
      icon: "mdi-account-circle",
      color: "#41916b",
      path: "/cadastrar-paciente",
      disabled: false,
    },
    {
      title: "Captação",
      icon: "mdi-water-check",
      color: "#a60c21",
      path: "/cadastrar-captacao",
      disabled: false,
    },
  ];
}

// MENU PCR
function getPcrMenu(item, getPDF, profile, permission) {  
  const status = getStatusSlug(item);

  const isFinal = pcrFinalStatus.includes(status);
  const canOpenDeathData = pcrDadosMorteAllowed.includes(status);
  const canEvaluate = pcrAvaliacaoAllowed.includes(status);
  const canDoAcceptance = pcrAceiteAllowed.includes(status);
  const captacaoDisabled = pcrCaptacaoBlocked.includes(status);
  const orgaosCaptadosEnabled = pcrOrgaosCaptadosAllowed.includes(status);

  return [
    {
      title: "Editar Dados Paciente",
      icon: "mdi-account-edit",
      color: "#41916b",
      path: "/cadastrar-paciente", 
      permission: permission(
        'cad_donor', 
        'cad_donor_pcr', 
        'insert_rgct'
      ),
      disabled: false,
    },
    {
      title: "Dados da Morte",
      icon: "mdi-account-details",
      color: "#41916b",
      path: "/dados-morte",
      permission: permission('cad_death_data'),
      disabled: !canOpenDeathData || isFinal,
    },
    {
      title: "Avaliação Potencial Doador",
      icon: "mdi-star-circle",
      color: "#41916b",
      path: "/validacao-doador-pcr",
      permission: permission('cad_donor'),
      disabled: !canEvaluate || isFinal,
    },
    {
      title: "Aceite Familiar",
      icon: "mdi-account-multiple-outline",
      color: "#41916b",
      path: "/aceite-familiar",
      permission: permission('cad_donor'),
      disabled: !canDoAcceptance || isFinal || !item?.cpf,
    },
    {
      title: "Anexos",
      icon: "mdi-paperclip",
      color: "#41916b",
      path: "/anexos",
      permission: permission(
        'cad_attachments', 
        'list_attachments'
      ),
      disabled: false,
    },
    {
      title: "Captação",
      icon: "mdi-water-check",
      color: "#41916b",
      path: "/cadastrar-captacao",
      permission: permission(
        'cad_captation', 
        'list_captation'
      ),
      disabled: captacaoDisabled,
    },
    {
      title: "Orgãos Captados",
      icon: "mdi-lungs",
      color: "#41916b",
      path: "/orgaos-captados",
      permission: permission(
        'cad_captation', 
        'list_captation'
      ),
      disabled: !orgaosCaptadosEnabled,
    },
    {
      title: "Histórico do Paciente",
      icon: "mdi-file-pdf-box",
      color: "red",
      path: "/orgaos-captados",
      permission: permission('list_donor'),
      disabled: false,
      click: () => getPDF(item),
    },

    canAccessAdmControl(profile) && {
      title: "Controle ADM",
      icon: "mdi-security",
      color: "black",
      path: "/adm-control",
      permission: permission('history_logs'),
      disabled: false,
    },
  ].filter((item) => item.permission != false).filter(Boolean);
}

// MENU ME

function getMeMenu(item, getPDF, profile, permission) { 
  const status = getStatusSlug(item);

  const isFinal = isMeFinalStatus(item, status);
  const canOpenGlasgow = meGlasgowAllowed.includes(status);
  const canOpenValidacao = meValidacaoAllowed.includes(status);
  const afterMedical = isMeAfterMedical(item, status);
  const captacaoDisabled = meCaptacaoBlocked.includes(status);
  const orgaosCaptadosEnabled = meOrgaosCaptadosAllowed.includes(status);
  const isAwaitingPMEClosure = mePMEAwaitingClosure.includes(status);

  return [
    {
      title: "Editar Dados Paciente",
      icon: "mdi-account-edit",
      color: "#41916b",
      path: "/cadastrar-paciente",
      permission: permission(
        'cad_donor', 
        'cad_donor_me', 
        'insert_rgct'
      ),
      disabled: false,
    },
    {
      title: "Exames Diários",
      icon: "mdi-stethoscope",
      color: "#41916b",
      path: "/cadastrar-exames",
      permission: permission(
        'list_entrace_exames', 
        'cad_entrace_exames',  
      ),
      disabled: false,
    },
    {
      title: "Escala de Glasgow",
      icon: "mdi-format-list-checks",
      color: "#41916b",
      path: "/escala-glasgow",
      permission: permission(
        'cad_glasgow_scale', 
        'list_glasgow_scale',  
      ),
      disabled: !canOpenGlasgow,
    },
    {
      title: "Informes Clínicos",
      icon: "mdi-format-list-bulleted",
      color: "#41916b",
      path: "/informes-clinicos",
      permission: permission(
        'list_clinical_reports',
        'cad_clinical_reports',
      ),
      disabled: isFinal,
    },
    {
      title: "Validação do Doador",
      icon: "mdi-account-star",
      color: "#41916b",
      path: "/validacao-doador-me",
      permission: permission('cad_donor_me'),
      disabled: !canOpenValidacao,
    },
    {
      title: "Encerramento PME",
      icon: "mdi-alert-circle-outline",
      color: "#41916b",
      path: "/ending_pme",
      permission: permission('cad_donor_me'),
      disabled: !isAwaitingPMEClosure,
    },
    {
      title: "Aceite Familiar",
      icon: "mdi-account-multiple-outline",
      color: "#41916b",
      path: "/aceite-familiar",
      permission: permission('cad_donor_me'),
      disabled: !afterMedical || isFinal || !item?.cpf,
    },
    {
      title: "Anexos",
      icon: "mdi-paperclip",
      color: "#41916b",
      path: "/anexos",
      permission: permission(
        'cad_attachments', 
        'list_attachments'
      ),
      disabled: false,
    },
    {
      title: "Captação",
      icon: "mdi-water-check",
      color: "#41916b",
      path: "/cadastrar-captacao",
      permission: permission(
        'cad_captation',
        'list_captation'
      ),
      disabled: captacaoDisabled,
    },
    {
      title: "Orgãos Captados",
      icon: "mdi-lungs",
      color: "#41916b",
      path: "/orgaos-captados",
      permission: permission(
        'cad_captation',
        'list_captation'
      ),
      disabled: !orgaosCaptadosEnabled,
    },
    {
      title: "Histórico do Paciente",
      icon: "mdi-file-pdf-box",
      color: "#db0b27",
      path: "/orgaos-captados",
      permission: permission('list_donor'),
      disabled: false,
      click: () => getPDF(item),
    },

    canAccessAdmControl(profile) && {
      title: "Controle ADM",
      icon: "mdi-security",
      color: "black",
      path: "/adm-control",
      permission: permission('history_logs'),
      disabled: false,
    },
  ].filter((item) => item.permission != false).filter(Boolean);
}

// FUNÇÃO PRINCIPAL

export function getMenuItemsByDonor({ item, profile, opoProfile, getPDF, permission }) { 

  if (isOpoProfile(opoProfile)) {
    return getOpoMenu();
  }

  // if (!isAdminProfile(profile)) {
  //   return [];
  // }

  if (isPCR(item)) {
    return getPcrMenu(item, getPDF, profile, permission);
  }

  if (isME(item)) {
    return getMeMenu(item, getPDF, profile, permission);
  }

  return [];
}
